/** 下タブ。片手で届く位置に置く（モバイルファースト・SPEC §7.7）。 */
import type { ReactNode } from 'react';
import { useRouter, type Route } from '../lib/router';

const icon = (d: string): ReactNode => (
  <svg viewBox="0 0 24 24" className="size-6" fill="none" stroke="currentColor" strokeWidth="1.7">
    <path d={d} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TABS: Array<{ route: Route; label: string; icon: ReactNode }> = [
  {
    route: { name: 'home' },
    label: 'ホーム',
    icon: icon('M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z'),
  },
  {
    route: { name: 'shopping-list' },
    label: '買い物',
    icon: icon('M4 5h2l1.6 9.3a2 2 0 0 0 2 1.7h6.9a2 2 0 0 0 2-1.6L20 8H7M9.5 20h.01M17 20h.01'),
  },
  { route: { name: 'dashboard' }, label: '費用', icon: icon('M5 20V10M12 20V4M19 20v-7') },
  {
    route: { name: 'settings' },
    label: '設定',
    icon: icon(
      'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.1 14.4a1.5 1.5 0 0 0 .3 1.7l.1.1a1.9 1.9 0 1 1-2.7 2.7l-.1-.1a1.5 1.5 0 0 0-2.5 1V20a1.9 1.9 0 1 1-3.8 0v-.1a1.5 1.5 0 0 0-2.5-1l-.1.1a1.9 1.9 0 1 1-2.7-2.7l.1-.1a1.5 1.5 0 0 0-1-2.5H4a1.9 1.9 0 1 1 0-3.8h.1a1.5 1.5 0 0 0 1-2.5l-.1-.1a1.9 1.9 0 1 1 2.7-2.7l.1.1a1.5 1.5 0 0 0 2.5-1V4a1.9 1.9 0 1 1 3.8 0v.1a1.5 1.5 0 0 0 2.5 1l.1-.1a1.9 1.9 0 1 1 2.7 2.7l-.1.1a1.5 1.5 0 0 0 1 2.5h.1a1.9 1.9 0 1 1 0 3.8H20a1.5 1.5 0 0 0-.9.3z',
    ),
  },
];

export function BottomNav({ shoppingCount = 0 }: { shoppingCount?: number }): ReactNode {
  const { route, navigate } = useRouter();
  // 品目詳細はホームの下位なのでホームを点灯させる
  const current = route.name === 'item' ? 'home' : route.name;

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-ink-700 bg-ink-900/95 backdrop-blur">
      <div className="mx-auto flex max-w-3xl">
        {TABS.map((tab) => {
          const active = tab.route.name === current;
          const badge = tab.route.name === 'shopping-list' ? shoppingCount : 0;
          return (
            <button
              key={tab.route.name}
              type="button"
              aria-current={active ? 'page' : undefined}
              onClick={() => navigate(tab.route)}
              className={`flex flex-1 flex-col items-center gap-0.5 pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))]
                text-[11px] font-medium transition-colors ${
                  active ? 'text-orange-400' : 'text-zinc-500 hover:text-zinc-300'
                }`}
            >
              <span className="relative">
                {tab.icon}
                {badge > 0 && (
                  <span
                    className="absolute -right-2.5 -top-1 min-w-4 rounded-full bg-orange-500 px-1
                      text-center text-[10px] font-bold leading-4 text-ink-950"
                  >
                    {badge > 99 ? '99+' : badge}
                  </span>
                )}
              </span>
              {tab.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
